import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useQueryParams } from '@shared/hooks/useQueryParams';
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrdersWithoutWeightFiltersPanel } from './OrdersWithoutWeightFiltersPanel';
import { DownloadExcelButton } from './DownloadExcelButton';
import type { AgGridTableProps } from '@shared/components/ui/AgGridTable';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  filterConditions: FilterConditionOutput[];
  searchTerm: string;
  sorting?: SortingConfig | null;
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  filterConditions,
  searchTerm,
  sorting,
}: FiltersSectionProps) => {
  const { t } = useTranslation('ordersWithoutWeightModule');
  const { getTeamType } = usePermissions();
  const hasTeamData = getTeamType() === 'tenant_3pl';
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  // Calcular número de filtros activos
  const activeFiltersCount = useMemo(() => {
    return filterConditions.length;
  }, [filterConditions]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('search.placeholder', 'Buscar pedido...')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />

      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="filters-toggle-button"
      >
        <OrdersWithoutWeightFiltersPanel
          initialConditions={filterConditions}
          onChange={onFilterChange}
          hasTeamData={hasTeamData}
        />
      </FiltersDropdown>

      <DownloadExcelButton filterConditions={filterConditions} sorting={sorting} />
    </>
  );
};
